exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cards[data-v-2bdda79e]{list-style:none;padding:0 0 10px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;justify-content:center;flex-wrap:wrap;width:100%;flex-grow:1}.countdown[data-v-2bdda79e]{font-size:42px;color:#f89623}", ""]);

// exports
